import React from 'react';
import {StyledTextField} from '@resurs-internal/mui';
import {useTranslate} from '../../../hooks';
import type {VerifyContactFlow} from '../useVerifyContactFlow';

export const EmailField: React.FC<{flow: VerifyContactFlow}> = ({flow}) => {
  const {value, setValue, isValueValid, isBusy, sendCode} = flow;
  const translate = useTranslate();
  return (
    <StyledTextField
      fullWidth
      outline={'single'}
      label={translate('common.email')}
      type={'email'}
      autoComplete={'email'}
      inputMode={'email'}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && isValueValid && !isBusy) sendCode();
      }}
      disabled={isBusy}
      error={Boolean(value) && !isValueValid}
    />
  );
};
